'use client';

import { useEffect } from 'react';

import { ContextStoreSearchSuggestion, storeSearchSuggestion } from './store';

interface ClientStoreSearchSuggestionProps {
  state: ContextStoreSearchSuggestion;
}

export function ClientStoreSearchSuggestion({
  state
}: ClientStoreSearchSuggestionProps) {
  useEffect(() => {
    storeSearchSuggestion.send({
      type: 'set',
      state
    });
  }, [state]);

  return null;
}
